function LoadingErrorCard() {
  return (
    <section className="bg-light text-danger grid gap-2 rounded-sm p-6 text-center shadow-xl">
      <h2 className="text-xl font-bold">Failed to load users</h2>
      <p className="leading-snug">Something went wrong, refresh to try again.</p>
    </section>
  );
}

export default LoadingErrorCard;
